<template>
  <router-view />
  <FloatingWindow/>
  <FloatingLinks/>
</template>
<script setup>
  import { ref, onMounted } from 'vue'
  import FloatingWindow from '@/components/FloatingWindow.vue'
  import FloatingLinks from '@/components/FloatingLinks.vue'

  onMounted(() => {
    //window.onresize = () => { location.reload(); }
  })
</script>